export const nullDateGMT = "Fri, 15 Oct 1582 00:00:00 GMT"

export default class UniDate {
  value: string = ''
  type: string = 'Date'

  constructor(date?: Date | string) {
    if (date instanceof Date) {
      this.value = date.toUTCString()
    } else {
      const tmp = new Date(date || '')
      if (!date || !tmp || isNaN(tmp.getTime())) {
        this.value = nullDateGMT
      } else {
        this.value = tmp.toUTCString()
      }
    }
  }

  /**
   * Сравнивает даты и возвращает:
   * -1 если текущая дата меньше date,
   * 1 если больше и 0 если равны
   */
  compareTo(date: UniDate): number {
    const thisTime = new Date(this.value).getTime()
    const anotherTime = new Date(date.value).getTime()
    return thisTime < anotherTime ? -1 : (thisTime === anotherTime ? 0 : 1)
  }

  before(other: unknown): boolean {
    const thisDate = UniDate.toDate(this.value)
    const otherDate = UniDate.toDate(other)
    if (!thisDate || !otherDate) {
      return false
    }

    return UniDate.toLocalCalendarDay(thisDate) < UniDate.toLocalCalendarDay(otherDate)
  }

  private static toLocalCalendarDay(date: Date): number {
    return date.getFullYear() * 10_000 + (date.getMonth() + 1) * 100 + date.getDate()
  }

  private static toDate(value: unknown): Date | null {
    if (value == null) {
      return null
    }
    if (value instanceof UniDate) {
      return UniDate.toDate(value.value)
    }
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value
    }
    if (typeof value === 'object' && 'value' in (value as object)) {
      return UniDate.toDate((value as { value?: unknown }).value)
    }
    const date = new Date(String(value))
    return Number.isNaN(date.getTime()) ? null : date
  }

  /**
   * Проверяет является ли дата null-датой
   */
  get isNull(): boolean {
    return this.value === nullDateGMT
  }

  static nullDate = new Date(nullDateGMT)
  static nullDateGMT = nullDateGMT
  static nullDateISO = (new Date(nullDateGMT)).toISOString()
}
